import { render } from "./SessionOverview.vue?vue&type=template&id=6e05c5d0"
import script from "./SessionOverview.vue?vue&type=script&lang=js"
export * from "./SessionOverview.vue?vue&type=script&lang=js"

import "./SessionOverview.vue?vue&type=style&index=0&id=6e05c5d0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__